import { useState, useCallback, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/anime';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  const handleScroll = useCallback(() => {
    setIsScrolled(window.scrollY > 20);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            onClick={scrollToTop}
            className="flex items-center gap-2 whitespace-nowrap cursor-pointer"
          >
            <span className="w-8 h-8 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg">
              <i className="ri-ancient-gate-line text-lg"></i>
            </span>
            <span className="font-heading text-xl font-bold text-foreground-900">
              风车动漫
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                onClick={scrollToTop}
                className={`px-3 py-2 text-sm rounded-md whitespace-nowrap cursor-pointer transition-colors duration-200 ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'bg-primary-100 text-primary-700 font-medium'
                    : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
                }`}
              >
                {cat.name}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about"
              onClick={scrollToTop}
              className={`px-4 py-2 text-sm rounded-md whitespace-nowrap cursor-pointer transition-colors duration-200 ${
                location.pathname === '/about'
                  ? 'bg-secondary-100 text-secondary-700 font-medium'
                  : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-100'
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 cursor-pointer"
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-1">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                onClick={() => {
                  setMobileOpen(false);
                  scrollToTop();
                }}
                className={`flex items-center gap-2 px-3 py-2.5 rounded-md text-sm cursor-pointer ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'bg-primary-100 text-primary-700 font-medium'
                    : 'text-foreground-600 hover:bg-background-100'
                }`}
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className={`${cat.icon} text-base`}></i>
                </span>
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              onClick={() => {
                setMobileOpen(false);
                scrollToTop();
              }}
              className={`flex items-center gap-2 px-3 py-2.5 rounded-md text-sm cursor-pointer ${
                location.pathname === '/about'
                  ? 'bg-secondary-100 text-secondary-700 font-medium'
                  : 'text-foreground-600 hover:bg-background-100'
              }`}
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-information-line text-base"></i>
              </span>
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}